import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Constants } from "../shared/Constants";
import { useIsMount } from "../shared/useIsMount";
import { Loading } from "../shared/useLoading";
import { useNavUtils } from "../shared/useNavUtils";
import FilterPopup from "./FilterPopup";
import InfoIconPopup from "./InfoIconPopup";
import "./MenuBar.scss";
import MobileDropdownPopup from "./MobileDropdownPopup";

const MenuBar: React.FC<{
  loading: Loading;
}> = (props): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const logo = require(`../../images/${process.env.REACT_APP_LOGO_IMAGE}`);

  const SEARCH_PATH = "/search";
  const location = useLocation();
  const isMount = useIsMount();
  const navUtils = useNavUtils();
  const [term, setTerm] = useState(Constants.EmptyString);
  const yearState = useState(Constants.EmptyString);
  const [year, setYear] = yearState;
  const [showBackButton, setShowBackButton] = useState(false);

  const clearSearch = () => {
    setTerm(Constants.EmptyString);
    setYear(Constants.EmptyString);
  };

  useEffect(() => {
    if (
      !location.pathname.startsWith(SEARCH_PATH) ||
      term !== Constants.EmptyString
    ) {
      return;
    }
    const encoded = location.pathname.substring(SEARCH_PATH.length + 1);
    const parts = encoded.split("/");
    if (parts.length === 1) {
      setTerm(decodeURIComponent(parts[0]));
    } else if (parts.length === 2) {
      setYear(decodeURIComponent(parts[0]));
      setTerm(decodeURIComponent(parts[1]));
    }
  }, [props.loading.loaded()]);

  useEffect(() => {
    if (isMount) {
      return;
    }
    if (
      term === Constants.EmptyString &&
      location.pathname.startsWith(SEARCH_PATH)
    ) {
      navUtils.home();
    }
  }, [term]);

  useEffect(() => {
    if (isMount) {
      return;
    }
    if (term !== Constants.EmptyString) {
      navUtils.search(term, year);
    }
  }, [year]);

  useEffect(() => {
    if (isMount) {
      return;
    }
    setShowBackButton(
      location.pathname.startsWith("/show") ||
        location.pathname.startsWith("/chords/")
    );
  }, [location]);

  return (
    <div className="ui fixed menu top MenuBar">
      <div className="ui container">
        {showBackButton ? (
          <a className="header item link go-back" onClick={navUtils.goBack}>
            <i className="left arrow circle big icon" />
          </a>
        ) : null}
        <a className="header item link" onClick={navUtils.home}>
          <img
            className="logo"
            src={logo.default}
            alt="steal your face"
            style={{ marginRight: "1.5em" }}
          />
          <span className="mobile-hidden">{process.env.REACT_APP_NAME}</span>
        </a>
        <div className="item search-box">
          <div className={`ui icon input`}>
            <input
              type="text"
              placeholder="Search..."
              spellCheck="false"
              onChange={(e) => {
                const term = e.target.value;
                setTerm(term);
                navUtils.search(term, year);
              }}
              onFocus={() => {
                if (term !== Constants.EmptyString) {
                  navUtils.search(term, year);
                }
              }}
              value={term}
            />
            {term !== Constants.EmptyString ? (
              <i className={`times circle link icon`} onClick={clearSearch} />
            ) : null}
          </div>
          <FilterPopup yearState={yearState} />
        </div>
        <a
          className="header item link time-machine mobile-hidden"
          onClick={navUtils.timeMachine}
        >
          <div>
            <i className="ui clock big icon" />
          </div>
        </a>
        <a
          className="header item link favorites mobile-hidden"
          onClick={navUtils.favorites}
        >
          <div>
            <i className="ui heart big icon" />
          </div>
        </a>
        <a
          className="header item link radio mobile-hidden"
          onClick={navUtils.radio}
        >
          <div>
            <i className="ui compact disc big icon" />
          </div>
        </a>
        <a
          className="header item link chords mobile-hidden"
          onClick={navUtils.chordsList}
        >
          <div>
            <i className="ui music big icon" />
          </div>
        </a>
        {process.env.REACT_APP_MENU_SHOW_INFO === "true" ? (
          <span className="header item link feedback mobile-hidden">
            <InfoIconPopup />
          </span>
        ) : null}
        <span className="header item link mobile-dropdown tablet-hidden">
          <MobileDropdownPopup />
        </span>
      </div>
    </div>
  );
};

export default MenuBar;
